module.exports = __webpack_public_path__ + "static/media/postpayimg.14bc328b.svg";